
import Loading from '../../../../Loading/Loading';
import Section from './Section';
import { AnswerSelectPresentationProps } from '../../config';
import { FC } from 'react';
import { IAnswerModel } from '../../../../../state/stores/Question/AnswerModel';
import { SPACING } from '../../../../../config/designSystem/Spacing';
import { ScrollView, StyleSheet, Text } from 'react-native';
import { observer } from 'mobx-react';
import { useStores } from '../../../../../hooks/useStores';

export interface IAnswerSelected extends IAnswerModel {
  selected?: boolean;
}

const _PresentSections: FC<AnswerSelectPresentationProps> = ({
  answers,
  onPress,
  loading,
  labels,
}) => {

  const { treeNav } = useStores();

  const sections = answers
    ?.filter(answer => answer.meta?.some(meta => meta.key === 'section') && !answer.meta?.some(meta => meta.key === 'option')) || [];
  const getOptions = (section: string) => answers
    ?.filter(answer => answer.meta?.some(meta => meta.key === 'section' && meta.value === section) && answer.meta.some(meta => meta.key === 'option'))
    .map(answer => ({
      ...answer,
      selected: treeNav.choices.pending?.answers.some(a => a.id === answer._id),
    })) || [];

  if (!sections?.length) {
    if (loading) {
      // loading entire set of sections
      return <Loading />;
    } else {
      // no sections available
      // TODO not expected to ever arrive here. log to sentry.
      return <Text>{labels?.NO_CONTENT}</Text>;
    }
  }

  return (
    <ScrollView
      contentContainerStyle={styles.scrollView}
      showsVerticalScrollIndicator={false}
    >
      {sections.map(section => (
        <Section
          key={section._id}
          section={section as IAnswerSelected}
          options={getOptions(section.wording as string)as IAnswerSelected[]}
          onPress={onPress}
        />
      ))}
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  scrollView: {
    display: 'flex',
    flexDirection: 'column',
    gap: SPACING['sp-16'],
    marginBottom: 10,
    justifyContent: 'center'
  },
});

export const PresentSections = observer(_PresentSections);
